/**
 * @description: 财务类型
 */
export enum FinanceTypeEnum {
  FIANCE_INCOME = 3, // 收入
  FIANCE_EXPENDITURE = 4 // 支出
}
